"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SPOTLIGHT_FORM_FACTOR_GATE = void 0;
const SPOTLIGHT_FORM_FACTOR_GATE = exports.SPOTLIGHT_FORM_FACTOR_GATE = 'LiveChat:SpotlightFormFactor';